import { VirtualScrollerDesignTokens } from '@primeng/themes/types/virtualscroller';

export const baseVirtualScrollerToken: VirtualScrollerDesignTokens = {
  css: () => `
    p-virtualscroller.disable-horizontal-scroll .p-virtualscroller-content {
      max-width: 100%;
    }
    `,
};
